document.addEventListener('click', (e) => {
  const btn = e.target.closest('.vrac-pro-qty__btn');
  if (!btn) return;

  const wrap = btn.closest('[data-vrac-pro-qty]');
  if (!wrap) return;

  const input = wrap.querySelector('.vrac-pro-qty__input');
  if (!input) return;

  const current = Math.max(1, parseInt(input.value || '1', 10));
  input.value = (btn.dataset.action === 'plus') ? current + 1 : Math.max(1, current - 1);
});
